import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=2123debd&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "./FAQ.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=2123debd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2123debd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2123debd')) {
      api.createRecord('2123debd', component.options)
    } else {
      api.reload('2123debd', component.options)
    }
    module.hot.accept("./FAQ.vue?vue&type=template&id=2123debd&scoped=true&", function () {
      api.rerender('2123debd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/Snippets/FAQ.vue"
export default component.exports